import axios from 'axios';
import { toast } from 'react-toastify';
import { API_ENDPOINTS } from './apiEndpoints';
import { BASE_URL } from '../shared/constant.js';

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 30000, 
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config: originalRequest } = error;
    if (!response) {
      toast.error("Network error. Please check your connection.");
      return Promise.reject(error);
    }
    if (response.status === 401) {
      try {
        const refreshToken = sessionStorage.getItem("refreshToken");
        if (!refreshToken) {
          sessionStorage.clear();
          window.location.href = "/";
          return Promise.reject(error);
        }
        const refreshResp = await axios.post(
          `${BASE_URL}${API_ENDPOINTS.ACCOUNTS.TOKEN_REFRESH}`,
          { refresh: refreshToken }
        );
        const newAccessToken = refreshResp.data?.access;
        if (!newAccessToken) {
          sessionStorage.clear();
          window.location.href = "/";
          return Promise.reject(error);
        }
        sessionStorage.setItem("accessToken", newAccessToken);
        apiClient.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return apiClient(originalRequest);
      } catch (err) {
        console.error("Refresh token failed:", err);
        sessionStorage.clear();
        window.location.href = "/";
        return Promise.reject(err);
      }
    }
    // toast.error(response.data?.message || "An error occurred");
    return Promise.reject(error);
  }
);

export const apiService = {
  get: async (url, config = {}) => {
    try {
      const response = await apiClient.get(url, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  post: async (url, data = {}, config = {}) => {
    try {
      const response = await apiClient.post(url, data, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  put: async (url, data = {}, config = {}) => {
    try {
      const response = await apiClient.put(url, data, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  patch: async (url, data = {}, config = {}) => {
    try {
      const response = await apiClient.patch(url, data, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (url, config = {}) => {
    try {
      console.log('API Service - DELETE request:', { url, config });
      const response = await apiClient.delete(url, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  upload: async (url, formData, config = {}) => {
    try {
      const response = await apiClient.post(url, formData, {
        ...config,
        headers: {
          'Content-Type': 'multipart/form-data',
          ...config.headers,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default apiService; 